import React from 'react';
import './App.css';
import { ReactComponent as Logo } from '../assets/logo.svg';
import vitamin from '../assets/sf-3-bottle.avif';
import AppBar from '@mui/material/AppBar';
import Container from '@mui/material/Container';
import SvgIcon from '@mui/material/SvgIcon';
import Grid2 from '@mui/material/Grid2';
import Box from '@mui/material/Box';
import useMediaQuery from '@mui/material/useMediaQuery';
import useTheme from '@mui/material/styles/useTheme';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import { useQuery } from 'react-query';

const Icon = () => {
  return (
    <SvgIcon component={Logo} inheritViewBox className='icon'/>
  )
}

const styles = {
  customizeToolbar: {
    minHeight: 75,
    backgroundColor: 'white',
    boxShadow: 'none',
    borderBottom: '1px solid #e0e0e0',
    display: 'flex',
    justifyContent: 'left'
  }
};

function App() {
  const theme = useTheme();
  const isMobileOrTablet = useMediaQuery(theme.breakpoints.down('md'));

  return (
    <div className="App">
      <AppBar position="static" sx={styles.customizeToolbar}>
        <Container maxWidth="xl" sx={{ display: 'flex', justifyContent: 'left', paddingLeft: '23px' }}>
          <Icon/>
        </Container>
      </AppBar>
      {isMobileOrTablet ? MobileCheckout() : DesktopCheckout()}
    </div>
  );
}

function KonnectiveCheckout(path: string) {
  const { isLoading, error, data } = useQuery('myData', async () => {
    const response = await fetch(''); // add connective endpoint
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  });
}

function GoogleCheckout() {
  const { isLoading, error, data } = useQuery('myData', async () => {
    const response = await fetch(''); // add google endpoint
    if (!response.ok) {
      throw new Error('Network response was not ok');
    }
    return response.json();
  });
}

function MobileCheckout() {
  const [isThankYouPage, setIsThankYouPage] = React.useState(false);

  let handlePayNow = () => {
    setIsThankYouPage(true);
  }

  return (
    <>
      {isThankYouPage ? 
      <ThankYouPage /> :
      (
        <>
          <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5'  }}>
            <Accordion sx={{ boxShadow: 'none', background: '#f5f5f5', /*borderBottom: '1px solid #e0e0e0'*/ }}>
              <AccordionSummary expandIcon={<DensitySmallIcon />}> 
                <div className='summary-header'>Order Summary</div>
              </AccordionSummary>
              <AccordionDetails sx={{ borderBottom: '1px solid #e0e0e0' }}>
                <div className="summary-item">
                <img src={vitamin} /><i>$59 per bottle</i>
                  <strong>Sugar Fix</strong>
                  <em>3 bottles</em>
                  <div className="clear"></div>
                  </div>
                  <hr />
                  <div className="summary-item">
                  <strong>Subtotal</strong>
                  <i>$177.00</i>
                  <div className="clear"></div>
                  </div>
                  <div className="summary-item">
                  <strong>Shipping</strong>
                  <i>$9.99</i>
                  <div className="clear"></div>
                  </div>
                  <div className="summary-item summary-total">
                  <strong>Total</strong>
                  <i>$186.99</i>
                  <div className="clear"></div>
                </div>
              </AccordionDetails>
            </Accordion>
          </AppBar>
          <Box className="container" sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex'}}>
            <form id="checkout-form">
              <h3>Contact</h3>
              <div className="form-row">
                  <input placeholder="Email" type="email" id="email" required/>
              </div>
              <div className="error" id="email-error"></div>
    
              <h3>Delivery</h3>
    
              <div className="form-row">
                  <select name="countryCode" id="Select0" required>
                      <option value="US">United States</option>
                  </select>
              </div>
    
              <div className="form-row">
                  <input placeholder="First name" type="text" id="first-name" required/>
                  <input placeholder="Last name" type="text" id="last-name" required/>
              </div>
              <div className="form-row">
                  <input type="text" id="company" placeholder="Company (required for business addresses)" required/>
              </div>
              <div className="form-row">
                  <input type="text" id="address1" placeholder="Address" required/>
              </div>
              <div className="form-row">
                  <input type="text" id="address2" placeholder="Apartment, suite, etc. (optional)" required/>
              </div>
              <div className="form-row">
                  <input type="text" id="city" placeholder="City" required/>
                  <input type="text" id="state" placeholder="State" required/>
                  <input type="text" id="zip" placeholder="ZIP Code" required/>
              </div>
              <h3>Payment</h3>
              <em>All transactions are secure and encrypted.</em>
              <div className="payment-container">
                  <div>
    
                      <img alt="VISA"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                          role="img" width="38" height="24"
                          className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
    
                      <img alt="MASTERCARD"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                          role="img" width="38" height="24"
                          className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
    
                      <img alt="AMEX"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                          role="img" width="38" height="24"
                          className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
    
                      <img alt="DISCOVER"
                          src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                          role="img" width="38" height="24"
                          className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>
    
                  </div>
                  <div className="form-row">
    
    
                      <input type="text" id="card-number" placeholder="Card Number" required/>
                  </div>
                  <div className="form-row">
                      <input type="text" id="exp-date" placeholder="MM/YY" required/>
                      <input type="text" id="cvv" placeholder="CVC" required/>
                  </div>
                  <div className="form-row">
                      <input type="text" id="name-on-card" placeholder="Name on card" required/>
                  </div>
                  <div className="form-norow">
                      <input type="checkbox" id="isBillingIsShippingAddress" />
                      <label>Use shipping address as billing address</label>
                  </div>
              </div>
    
              <br />
              <em>Secure and encrypted</em>
              <button type="submit" className="pay-button" onClick={handlePayNow}>Pay Now</button>
    
              <em>Your info will be saved to a Shop account. By continuing, you agree to Shop’s Terms of Service and
                  acknowledge the Privacy Policy.</em>
              <hr />
              <em>
                  <div>
                      <a href="#">Refund policy</a>
                      <a href="#">Privacy policy</a>
                      <a href="#">Terms of service</a>
                  </div>
                  <div>
                      By placing this order, you agree to our Terms of Service and understand our Privacy Policy.
                  </div>
              </em>
            </form>
          </Box>
        </>
      )}
    </>
  );
}

function DesktopCheckout() {
  const [isThankYouPage, setIsThankYouPage] = React.useState(false);

  let handlePayNow = () => {
    setIsThankYouPage(true);
  }

  return (
    <>
      {isThankYouPage ? 
      <ThankYouPage /> :
      (
      <>
        <Grid2 container columns={16}>
          <Grid2 size={8} sx={{backgroundColor: 'white'}}>
            <Box className="container" sx={{paddingTop: '20px'}}>
              <form id="checkout-form">
                <h3>Contact</h3>
                <div className="form-row">
                    <input placeholder="Email" type="email" id="email" required/>
                </div>
                <div className="error" id="email-error"></div>

                <h3>Delivery</h3>

                <div className="form-row">
                    <select name="countryCode" id="Select0" required>
                        <option value="US">United States</option>
                    </select>
                </div>

                <div className="form-row">
                    <input placeholder="First name" type="text" id="first-name" required/>
                    <input placeholder="Last name" type="text" id="last-name" required/>
                </div>
                <div className="form-row">
                    <input type="text" id="company" placeholder="Company (required for business addresses)" required/>
                </div>
                <div className="form-row">
                    <input type="text" id="address1" placeholder="Address" required/>
                </div>
                <div className="form-row">
                    <input type="text" id="address2" placeholder="Apartment, suite, etc. (optional)" required/>
                </div>
                <div className="form-row">
                    <input type="text" id="city" placeholder="City" required/>
                    <input type="text" id="state" placeholder="State" required/>
                    <input type="text" id="zip" placeholder="ZIP Code" required/>
                </div>
                <h3>Payment</h3>
                <em>All transactions are secure and encrypted.</em>
                <div className="payment-container">
                    <div>

                        <img alt="VISA"
                            src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/visa.sxIq5Dot.svg"
                            role="img" width="38" height="24"
                            className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>

                        <img alt="MASTERCARD"
                            src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/mastercard.1c4_lyMp.svg"
                            role="img" width="38" height="24"
                            className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>

                        <img alt="AMEX"
                            src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/amex.Csr7hRoy.svg"
                            role="img" width="38" height="24"
                            className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>

                        <img alt="DISCOVER"
                            src="https://cdn.shopify.com/shopifycloud/checkout-web/assets/c1.en/assets/discover.C7UbFpNb.svg"
                            role="img" width="38" height="24"
                            className="_1tgdqw61 _1tgdqw60 _1fragemsm _1fragemsh _1fragemsw _1fragemoj _1tgdqw66"/>

                    </div>
                    <div className="form-row">


                        <input type="text" id="card-number" placeholder="Card Number" required/>
                    </div>
                    <div className="form-row">
                        <input type="text" id="exp-date" placeholder="MM/YY" required/>
                        <input type="text" id="cvv" placeholder="CVC" required/>
                    </div>
                    <div className="form-row">
                        <input type="text" id="name-on-card" placeholder="Name on card" required/>
                    </div>
                    <div className="form-norow">
                        <input type="checkbox" id="isBillingIsShippingAddress" />
                        <label>Use shipping address as billing address</label>
                    </div>
                </div>

                <br />
                <em>Secure and encrypted</em>
                <button type="submit" className="pay-button" onClick={handlePayNow}>Pay Now</button>

                <em>Your info will be saved to a Shop account. By continuing, you agree to Shop’s Terms of Service and
                    acknowledge the Privacy Policy.</em>
                <hr />
                <em>
                    <div>
                        <a href="#">Refund policy</a>
                        <a href="#">Privacy policy</a>
                        <a href="#">Terms of service</a>
                    </div>
                    <div>
                        By placing this order, you agree to our Terms of Service and understand our Privacy Policy.
                    </div>
                </em>
              </form>
            </Box>
          </Grid2>
          <Grid2 size={8}>
            <Box className="summary-container">
              <AppBar position='sticky' className='summary-header' sx={{ color: 'black', boxShadow: 'none', background: '#f5f5f5' }}>
                <div className="summary-header">Order Summary</div>
                <div className="summary-item">
                  <img src={vitamin} /><i>$59 per bottle</i>
                  <strong>Sugar Fix</strong>
                  <em>3 bottles</em>
                  <div className="clear"></div>
                  </div>
                  <hr />
                  <div className="summary-item">
                  <strong>Subtotal</strong>
                  <i>$177.00</i>
                  <div className="clear"></div>
                  </div>
                  <div className="summary-item">
                  <strong>Shipping</strong>
                  <i>$9.99</i>
                  <div className="clear"></div>
                  </div>
                  <div className="summary-item summary-total">
                  <strong>Total</strong>
                  <i>$186.99</i>
                  <div className="clear"></div>
                </div>
              </AppBar>
            </Box>
          </Grid2>
        </Grid2>
      </>
      )}
    </>
  );
}

function ThankYouPage() {
  return (
    <>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingBottom: '0'}}>
        <h1>Thank you for your purchase!</h1>
      </Box>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingTop: '0'}}>
          <p>We have received your order and will be processing it shortly</p>
      </Box>
      <Box sx={{padding: '20px', justifyContent: 'center', alignItems: 'center', display: 'flex', paddingTop: '0'}}>
        <p>Order Number:</p>
        <a href="https://crm.konnektive.com/">085a5a0a</a>
      </Box>
    </>

  );
}

export default App;
